import type { Problem } from "./types";

let antiforgeryToken: string | null = null;
export const resetAntiforgeryToken = () => { antiforgeryToken = null; };

async function getToken() {
  if (antiforgeryToken) return antiforgeryToken;
  const response = await fetch("/api/v1/auth/antiforgery", { credentials: "include" });
  const data = (await response.json()) as { token: string };
  antiforgeryToken = data.token;
  return antiforgeryToken;
}

export class ApiError extends Error {
  constructor(public status: number, public problem: Problem) {
    super(problem.detail ?? problem.title ?? "The request could not be completed.");
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const method = init?.method?.toUpperCase() ?? "GET";
  const headers = new Headers(init?.headers);
  headers.set("Accept", "application/json");
  if (init?.body && !(init.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (!["GET", "HEAD", "OPTIONS"].includes(method)) headers.set("X-XSRF-TOKEN", await getToken());
  const response = await fetch(`/api/v1${path}`, { ...init, headers, credentials: "include" });
  if (response.ok && (path === "/auth/login" || path === "/auth/logout")) resetAntiforgeryToken();
  if (response.status === 204) return undefined as T;
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiError(response.status, body as Problem);
  return body as T;
}

export const json = (value: unknown) => JSON.stringify(value);
